var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIshaClientTenderjordan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1177 54.5886V45.7357H37.7942V43.5298H46.6471V45.7357H43.3236V54.5886H41.1177Z",
    fill: "#454545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8529 54.7059L47.647 52.5V48.0882L49.8529 45.8823H54.2646L56.4705 48.0882V51.4117H49.8529L50.9705 52.5294H53.1764L53.7352 51.9706H56.4999V52.5294L54.294 54.7353H49.8529V54.7059ZM54.2646 49.2058L53.147 48.0882H50.9411L49.8234 49.2058H54.2646Z",
    fill: "#454545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6765 54.5883V45.7354H64.2942L65.4118 46.853V54.5883H63.2059V47.9706H59.8824V54.5883H57.6765Z",
    fill: "#454545"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5293 54.5881V45.7351H72.0587V42.4116H74.2646V54.5587H66.5293V54.5881ZM72.0587 52.3822V47.9704H68.7352V52.3822H72.0587Z",
    fill: "#454545"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5882 54.5882L75.3823 52.3823V47.9705L77.5882 45.7646H82L84.2059 47.9705V51.2941H77.5882L78.7059 52.4117H80.9117L81.4706 51.8529H84.2353V52.4117L82.0294 54.6176H77.5882V54.5882ZM82 49.0882L80.8823 47.9705H78.6764L77.5588 49.0882H82Z",
    fill: "#454545"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3237 54.5883V45.7354H90.8531L91.9708 46.853V50.1765H89.7649V47.9706H87.559V54.5883H85.3237Z",
    fill: "#454545"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.353 57.912V55.7061H97.4707V45.7649H99.6766V57.912H96.353ZM97.4707 44.6473V42.4414H99.6766V44.6473H97.4707Z",
    fill: "#454545"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103 54.5882L100.794 52.3823V47.9705L103 45.7646H107.412L109.617 47.9705V52.3823L107.412 54.5882H103ZM106.323 52.3823L107.441 51.2646V49.0588L106.323 47.9411H104.117L103 49.0588V51.2646L104.117 52.3823H106.323Z",
    fill: "#454545"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.735 54.5883V45.7354H116.265L117.382 46.853V50.1765H115.176V47.9706H112.941V54.5883H110.735Z",
    fill: "#454545"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.47 54.5881V45.7351H124V42.4116H126.206V54.5587H118.47V54.5881ZM124 52.3822V47.9704H120.676V52.3822H124Z",
    fill: "#454545"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.529 54.5882L127.323 52.3823V47.9705L129.529 45.7646H132.853L133.971 46.8823V45.7646H136.176V54.6176H133.971V53.4999L132.853 54.6176H129.529V54.5882ZM132.853 52.3823L133.971 51.2646V49.0588L132.853 47.9411H130.647L129.529 49.0588V51.2646L130.647 52.3823H132.853Z",
    fill: "#454545"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.265 54.5883V45.7354H143.882L145 46.853V54.5883H142.794V47.9706H139.471V54.5883H137.265Z",
    fill: "#454545"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0294 63.5588C14.6471 63.5588 8.64706 57.5588 8.64706 50.1765C8.64706 42.7941 14.6471 36.7941 22.0294 36.7941C28.0882 36.7941 33.2059 40.8235 34.8529 46.3235C33.1471 39.7941 27.2353 35 20.1765 35C11.7941 35 5 41.7941 5 50.1765C5 58.5588 11.7941 65.3529 20.1765 65.3529C27.2353 65.3529 33.1471 60.5294 34.8529 54.0294C33.2059 59.5294 28.0882 63.5588 22.0294 63.5588Z",
    fill: "url(#paint0_linear_688_278)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1176 37.5884C19.6765 37.5884 17.3823 38.2943 15.4412 39.5296C16.9118 38.8531 18.5588 38.4707 20.3235 38.4707C26.7647 38.4707 31.9706 43.6766 31.9706 50.1178C31.9706 56.559 26.7647 61.7649 20.3235 61.7649C18.5882 61.7649 16.9412 61.3825 15.4412 60.706C17.3823 61.9413 19.6765 62.6472 22.1176 62.6472C29.0294 62.6472 34.647 57.0296 34.647 50.1178C34.647 43.206 29.0294 37.5884 22.1176 37.5884Z",
    fill: "url(#paint1_linear_688_278)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4119 43.7939V51.9704C25.4119 53.0292 24.5589 53.8528 23.5295 53.8528H21.9119V56.5586H24.4707C26.706 56.5586 28.5001 54.7645 28.5001 52.5292V43.7939H25.4119Z",
    fill: "url(#paint2_linear_688_278)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 46.8822V43.7939H11.3823V46.8822H15.7059V56.5586H18.7941V46.8822H23.147Z",
    fill: "url(#paint3_linear_688_278)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_688_278",
    x1: 33.107,
    y1: 44.6539,
    x2: 6.73444,
    y2: 55.9284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BCAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437ABE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_688_278",
    x1: 33.3787,
    y1: 45.2897,
    x2: 7.00622,
    y2: 56.5642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BCAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437ABE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_688_278",
    x1: 33.9043,
    y1: 46.5185,
    x2: 7.53175,
    y2: 57.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BCAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437ABE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_688_278",
    x1: 32.321,
    y1: 42.8152,
    x2: 5.94844,
    y2: 54.0897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BCAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437ABE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIshaClientTenderjordan);
export default __webpack_public_path__ + "static/media/isha-client-tenderjordan.6cdeed88a612521c6963aab91dc129bf.svg";
export { ForwardRef as ReactComponent };